// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"21":"d58b6747","478":"95c677f0","551":"dd45baf9","626":"3c1d6348","889":"36976b68"}[chunkId] + ".chunk.css";
};